import { Filter } from "../libs/models/filter";
import buildQuery from "odata-query";

const hasUndefinedValue = (obj: any): boolean => {
  if (obj == null) return true;
  if (typeof obj !== "object") return false;

  return Object.values(obj).some((value) =>
    Array.isArray(value)
      ? value.some(hasUndefinedValue)
      : hasUndefinedValue(value)
  );
};

const getFilterQuery = (filter: Filter, skip: number, top: number): string => {
  const { search, orderBy, dateProp, ...restFilters } = filter;

  const filterObj = [
    ...(search?.value ? [`startswith(${search.key},'${search.value}')`] : []),
    ...Object.entries(restFilters)
      .filter(([_, value]) => !hasUndefinedValue(value))
      .map(([key, value]) => ({ [key]: value })),
  ];

  const query = buildQuery({
    filter: filterObj,
    skip,
    top,
    orderBy: orderBy?.sort ? `${orderBy.key} ${orderBy.sort}` : undefined,
  });

  const dateParams = [
    dateProp?.from != null ? `&From=${dateProp.from}` : "",
    dateProp?.to != null ? `&To=${dateProp.to}` : "",
  ].join("");

  return `${query}${dateParams}`;
};

export { getFilterQuery };
